import React from "react";
import { Box } from "app/material-framework/materialComponents";
import { ChatbotInput } from "./ChatbotInput";
import { ContinueConversationPrompt } from "./ChatContinuePopup";

export function ChatInputArea({
  showContinuePrompt,
  onContinueYes,
  onContinueNo,
  input,
  onInputChange,
  onSend,
  onKeyDown,
  loading,
  isPopout
}) {
  return (
    <Box className={"chat-input-area"} sx={{ display: "flex", p: 2, bgcolor: "#EFEFEF", borderRadius: isPopout ? "0 0 18px 18px" : 0 }}>
      {showContinuePrompt ? (
        <ContinueConversationPrompt
          open={showContinuePrompt}
          onYes={onContinueYes}
          onNo={onContinueNo}
          highlighted={showContinuePrompt}
        />
      ) : (
        <ChatbotInput
          value={input}
          onChange={onInputChange}
          onSend={onSend}
          onKeyDown={onKeyDown}
          disabled={loading}
          sx={{ fontSize: "0.9rem" }}
        />
      )}
    </Box>
  );
}
